import script from "./IncomingCallModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./IncomingCallModal.vue?vue&type=script&setup=true&lang=ts"

import "./IncomingCallModal.vue?vue&type=style&index=0&id=2ff68028&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ff68028"]])

export default __exports__